import React from 'react';

import {
  Stack,
  Breadcrumbs,
  Menu,
  MenuItem,
  Button,
  KeyboardArrowRightIcon,
  Typography,
  ArrowDropUpIcon,
  ArrowDropDownIcon,
} from '@gogame/components';

import ScreenLink from '../ScreenLink';
import { useNavigation } from '../ScreensContext';
import { useBreadcrumbs } from './useBreadcrumbs';
import { useTitle } from './useTitle';
import { useCurrentBreadcrumb } from './useCurrentBreadcrumb';

const SubNavigation = ({ title, navigation }) => {
  return (
    <Menu
      anchor={({ onClick, open }) => (
        <Button
          color={'inherit'}
          style={{
            fontSize: 20,
            fontWeight: 500,
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: 0,
            textTransform: 'none',
            lineHeight: '28px',
          }}
          data-cy={'SubNavigationOpener'}
          onClick={onClick}
          endIcon={open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
        >
          {title}
        </Button>
      )}
    >
      {navigation.map(({ title, link }) => (
        <MenuItem
          key={title}
          component={ScreenLink}
          link={link}
          color={'inherit'}
          underline={'none'}
        >
          {title}
        </MenuItem>
      ))}
    </Menu>
  );
};

const BreadcrumbItem = ({ link, title, params, linkable }) => {
  return (
    <Typography variant={'caption'}>
      {linkable ? (
        <ScreenLink link={link} params={params}>
          {title}
        </ScreenLink>
      ) : (
        title
      )}
    </Typography>
  );
};

export const ScreenBreadcrumbs = () => {
  const rootNavigation = useNavigation();
  const breadcrumbs = useBreadcrumbs();
  const {title, icon} = useCurrentBreadcrumb();


  let navigation = breadcrumbs.length
    ? breadcrumbs.reduce((nav, bItem) => {
        return nav?.find((nItem) => nItem.link === bItem.link)?.children;
      }, rootNavigation)
    : [];

  const hasSubNavigation = navigation && navigation.length > 1;
  const currentItem = hasSubNavigation ? (
    <SubNavigation navigation={navigation} title={title} />
  ) : (
    <Typography
      color={'inherit'}
      variant={'h6'}
      noWrap={true}
      disableTooltip={true}
    >
      {icon ? <>{icon} </> : null}
      {title}
    </Typography>
  );

  return (
    <Stack alignItems={'start'}>
      <Breadcrumbs
        separator={
          <KeyboardArrowRightIcon sx={{ fontSize: 14 }} color={'inherit'} />
        }
      >
        {breadcrumbs.map(({ title, link, params, linkable }, i) => {
          return (
            <BreadcrumbItem
              title={title}
              link={link}
              linkable={linkable}
              params={params}
              key={i}
            />
          );
        })}
      </Breadcrumbs>
      <Stack maxWidth={'100%'}>{currentItem}</Stack>
    </Stack>
  );
};
